import React from "react";
import ReactDOM from "react-dom/client";
import "./styles/index.css";
import "./styles/login.css";
import RoutesSetting from "./RoutesSetting";
import reportWebVitals from "./reportWebVitals";
import URL from "./common/api/ConstantURL";
import * as APIService from "./common/api/index.js";
import { setToLocalStorage } from "./common/utils/localStorage";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle.min";
import * as Sentry from "@sentry/react";

Sentry.init({
  dsn: "https://f93b2ab1463f2c5a54e3cc877a37095c@appmonitor.e2infosystems.in/15",
  environment: process.env.NODE_ENV,
});

const root = ReactDOM.createRoot(document.getElementById("root"));
const APP_VERSION_KEY = "appVersion";

const getVersionFromResponse = (responseData) => {
  if (!responseData) return "";
  if (typeof responseData?.data === "string") {
    return responseData.data.trim();
  }
  if (typeof responseData?.version === "string") {
    return responseData.version.trim();
  }

  if (typeof responseData === "string") {
    return responseData.trim();
  }

  return "";
};
const preloadAppVersion = async () => {
  try {
    const controller = new AbortController();
    const timeout = setTimeout(() => controller.abort(), 3000);
    const responseData = await APIService.getData(`${URL.getAppVersion}?_ts=${Date.now()}`, { signal: controller.signal });
    clearTimeout(timeout);
    const version = getVersionFromResponse(responseData);
    if (version) {
      setToLocalStorage(APP_VERSION_KEY, version);
    }
  } catch (error) {
    console.warn("App version fetch skipped:", error?.message || error);
  }
};
root.render(<RoutesSetting />);
preloadAppVersion();
reportWebVitals();
